<template>
            <main class="main">
                <div class="main__title">
                    <div class="avatar_wrapper">
                      <div class="avatar_hover">
                        <img src="../../assets/img/avatar.png" alt="change photo"  @click="fileInput">
                        <img src="@/assets/icons/trash_white.svg" v-if="url != 'https://api.superbaer24.ru/storage/'" class="photo_trash" @click="deletePhoto">
                      </div>
                      <img :src="getAvatar(url)" v-if="getAvatar(url) != null" alt="" class="avatar">
                      <div style="font-size: 10px" v-else>Нет фотографии</div>
                    </div>
                    <!--<button @click="fileInput">Добавить фотографию</button>-->
                    <input type="file" ref="file" hidden name="photo" accept=".jpg, .jpeg, .png, .bmp" @change="onFileChange">
                </div>
                <div class="main__body">
                    <div class="main__body-column">
                        <h4>Фамилия</h4>
                        <div class="input-block">
                            <input autocomplete="off" name="surname" v-model="surname" v-validate="'required'" data-vv-validate-on="blur" type="text">
                            <span class="text-danger text-sm">{{ errors.first('surname') }}</span>
                        </div>
                        <h4>Имя</h4>
                        <div class="input-block">
                            <input autocomplete="off" name="name" v-model="name" v-validate="'required'" data-vv-validate-on="blur" type="text">
                            <span class="text-danger text-sm">{{ errors.first('name') }}</span>
                        </div>
                        <h4>Отчество</h4>
                        <div class="input-block">
                            <input autocomplete="off" name="patronymic" v-model="patronymic" type="text">
                            <!--<span class="text-danger text-sm">{{ errors.first('patronymic') }}</span>-->
                        </div>
                        <h4>Роль на платформе</h4>
                        <div class="input-block">
                            <input autocomplete="off" v-model="role" disabled>
                        </div>
                        <h4>Должность</h4>
                        <div class="input-block">
                            <input autocomplete="off" name="position" v-model="position" v-validate="'required'" data-vv-validate-on="blur" type="text">
                            <span class="text-danger text-sm">{{ errors.first('position') }}</span>
                        </div>
                        <h4>Город</h4>
                        <div class="input-block">
                            <input autocomplete="off" name="city" v-model="city" v-validate="'required'" data-vv-validate-on="blur" type="text">
                            <span class="text-danger text-sm">{{ errors.first('city') }}</span>
                        </div>
                        <h4>Часовой пояс</h4>
                        <div class="input-block">
                            <app-select v-model="timezone" :options="getZones()" label="title" :reduce="(option) => option.name"/>
                        </div>
                        <!--<h4>Логин</h4>
                        <input type="text">-->
                    </div>

                    <div class="main__body-column">
                        <h4>Рабочий телефон</h4>
                        <div class="input-block">
                            <input autocomplete="off" name="worker_phone" v-model="worker_phone" v-validate="'required'" data-vv-validate-on="blur" type="text" class="phone-input">
                            <span class="text-danger text-sm">{{ errors.first('worker_phone') }}</span>
                            <span class="text-danger text-sm" v-if="worker_phone_error && !errors.first('worker_phone')">{{ worker_phone_error }}</span>
                        </div>
                        <h4>Мобильный телефон</h4>
                        <div class="input-block">
                            <input autocomplete="off" name="mobile_phone" v-model="mobile_phone" v-validate="'required'" data-vv-validate-on="blur" type="text" class="phone-input">
                            <span class="text-danger text-sm">{{ errors.first('mobile_phone') }}</span>
                            <span class="text-danger text-sm" v-if="mobile_phone_error && !errors.first('mobile_phone') ">{{ mobile_phone_error }}</span>
                        </div>
                        <h4>Дополнительный телефон</h4>
                        <div class="input-block">
                            <input autocomplete="off" v-model="additional_phone" type="text" class="phone-input">
                            <span class="text-danger text-sm" v-if="additional_phone_error">{{ additional_phone_error }}</span>
                        </div>
                        <h4>Скайп</h4>
                        <div class="input-block">
                            <input autocomplete="off" v-model="skype">
                        </div>
                        <h4>E-mail</h4>
                        <div class="input-block">
                            <input autocomplete="off" name="email" v-model="email" v-validate="'required|email'" data-vv-validate-on="blur" type="text">
                            <span class="text-danger text-sm">{{ errors.first('email') }}</span>
                        </div>
                        <h4>О себе</h4>
                        <div class="input-block">
                            <textarea v-model="about" cols="30" rows="5"/>
                        </div>
                        <div class="pass">
                            <span class="password-label"><b>Смена пароля</b></span>
                            <!--<a href="#">Изменить пароль</a>-->
                        </div>
                        <div class="input-block">
                            <app-password v-model="old_password" label="Старый пароль" data-vv-as="старый пароль" name="old_password" v-validate="'min:5|max:24|alpha_dash'" data-vv-validate-on="blur"/>
                            <span class="text-danger text-sm">{{ errors.first('old_password') }}</span>
                            <!--<div class="password">
                                <input name="password" v-model="password" type="password" data-vv-validate-on="blur" v-validate="'min:8|max:24|alpha_dash'">
                                <button></button>
                            </div>-->
                        </div>
                        <div class="input-block">
                            <app-password v-model="new_password" label="Новый пароль" data-vv-as="новый пароль" name="new_password" v-validate="'min:5|max:24|alpha_dash'" data-vv-validate-on="blur"/>
                            <span class="text-danger text-sm">{{ errors.first('new_password') }}</span>
                        </div>
                      <app-button @click="send()">Сохранить</app-button>
                    </div>
                </div>
            </main>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Inputmask from 'inputmask'
import AppSelect from "@/components/app-select";
import AppPassword from "@/components/app-password";
import AppButton from "@/components/app-button";
import store from "@/store";

export default {
  name: "profile",
  components: { AppButton, AppSelect, AppPassword },
  data: ()=>({
    surname: '',
    name: '',
    patronymic: '',
    role: '',
    city: '',
    worker_phone: '',
    mobile_phone: '',
    additional_phone: '',
    skype: '',
    email: '',
    about: '',
    new_password: '',
    old_password: '',
    token: '',
    file: '',
    url: '',
    position: '',
    timezone: '',
    worker_phone_error: '',
    additional_phone_error: '',
    mobile_phone_error: '',
    user: []
  }),
  async mounted () {
    let im = new Inputmask("+7(999) 999 99 99");
    Array.prototype.forEach.call(document.getElementsByClassName("phone-input"), function(el) {
      im.mask(el);
    });
    await this.fetchUserInfo()
    this.setInfoToModels()
    this.role = localStorage.getItem('type') == 1 ? 'Поставщик' : 'Закупщик';
  },
  computed: {
    ...mapGetters(['getUser'])
  },
  beforeRouteLeave (to, from, next) {
    // If the form is dirty and the user did not confirm leave,
    // prevent losing unsaved changes by canceling navigation
    if (this.confirmStayInDirtyForm()){
      next(false)
    } else {
      // Navigate to next view
      next()
    }
  },
  created() {
    window.addEventListener('beforeunload', this.beforeWindowUnload)
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.beforeWindowUnload)
  },
  methods: {
    ...mapActions(['fetchUserInfo']),
    getAvatar(avatar){
      if(avatar == 'https://api.superbaer24.ru/storage/') return require('@/assets/icons/user.svg')
      else return avatar
    },
    confirmLeave() {
      return window.confirm('Вы действительно хотите уйти? Несохраненные данные будут утеряны!')
    },

    confirmStayInDirtyForm() {
      return this.dirty() && !this.confirmLeave()
    },
    dirty() {
      if (this.surname != this.user.surname) {
        return true;
      }
      if (this.name != this.user.name) {
        return true;
      }
      if (this.patronymic != this.user.patronymic) {
        return true;
      }
      if (this.city != this.user.city) {
        return true;
      }
      if (this.worker_phone != this.user.worker_phone) {
        return true;
      }
      if (this.mobile_phone != this.user.phone) {
        return true;
      }
      if (this.additional_phone != this.user.additional_phone) {
        return true;
      }
      if (this.skype != this.user.skype) {
        return true;
      }
      if (this.email != this.user.email) {
        return true;
      }
      if (this.about != this.user.about) {
        return true;
      }
      if (this.position != this.user.profile_position) {
        return true;
      }

      return false;
    },
    afterSave() {
      this.user.surname = this.surname;
      this.user.name = this.name;
      this.user.patronymic = this.patronymic;
      this.user.city = this.city;
      this.user.worker_phone = this.worker_phone;
      this.user.phone = this.mobile_phone;
      this.user.additional_phone = this.additional_phone;
      this.user.skype = this.skype;
      this.user.email = this.email;
      this.user.about = this.about;
      this.user.profile_position = this.position;
    },
    beforeWindowUnload(e) {
      if (this.confirmStayInDirtyForm()) {
        // Cancel the event
        e.preventDefault()
        // Chrome requires returnValue to be set
        e.returnValue = ''
      }
    },
    onFileChange(e) {
      let t = e.target.files[0].type.split('/').pop().toLowerCase();
      if (t != "jpeg" && t != "jpg" && t != "png" && t != "bmp") {
        this.$refs.file.value = ''
        return this.$toast.error('Загружаемый файл должен быть изображением!')
      }
      if (e.target.files[0].size > 5000000) {
        this.$refs.file.value = ''
        return this.$toast.error('Загружаемый файл должен иметь размер не более 5 мб.!')
      }
      this.file = e.target.files[0];
      this.url = URL.createObjectURL(this.file);
    },
    fileInput() {
      this.$refs.file.click();
    },
    getZones(){
      let arr = this.$moment.tz.zonesForCountry('RU', true);
      // this.$moment.tz.zonesForCountry('BY', true).forEach((item)=>{ Белорусь пока чилит
      //   arr.push(item)
      // })
      let rus_name_time_zone = {
        "Asia/Anadyr": "Азия/Анадырь",
        "Asia/Barnaul": "Азия/Барнаул",
        "Asia/Chita": "Азия/Чита",
        "Asia/Irkutsk": "Азия/Иркутск",
        "Asia/Kamchatka": "Азия/Петропавловск-Камчатский",
        "Asia/Khandyga": "Азия/Хандыга",
        "Asia/Krasnoyarsk": "Азия/Красноярск",
        "Asia/Magadan": "Азия/Магадан",
        "Asia/Novokuznetsk": "Азия/Новокузнецк",
        "Asia/Novosibirsk": "Азия/Новосибирск",
        "Asia/Omsk": "Азия/Омск",
        "Asia/Sakhalin": "Азия/Южно-Сахалинск",
        "Asia/Srednekolymsk": "Азия/Среднеколымск",
        "Asia/Tomsk": "Азия/Томск",
        "Asia/Ust-Nera": "Азия/Усть-Нера",
        "Asia/Vladivostok": "Азия/Владивосток",
        "Asia/Yakutsk": "Азия/Якутск",
        "Asia/Yekaterinburg": "Азия/Екатеринбург",
        "Europe/Astrakhan": "Европа/Астрахань",
        "Europe/Kaliningrad": "Европа/Калининград",
        "Europe/Kirov": "Европа/Киров",
        "Europe/Moscow": "Европа/Москва",
        "Europe/Samara": "Европа/Самара",
        "Europe/Saratov": "Европа/Саратов",
        "Europe/Simferopol": "Европа/Симферополь",
        "Europe/Ulyanovsk": "Европа/Ульяновск",
        "Europe/Volgograd": "Европа/Волгоград",
      };
      arr.map((item)=>{
        item.title = `(UTC ${this.$moment.tz(item.name).format('Z')}) ${rus_name_time_zone[item.name]}`
      })
      return arr.sort((a, b) => b.offset - a.offset)
    },
    setInfoToModels(){
      console.log ('1',this.getUser)
      if(this.getUser != null) {
        this.surname = this.getUser.surname
        this.name = this.getUser.name
        this.patronymic = this.getUser.patronymic
        this.city = this.getUser.city
        this.worker_phone = this.getUser.worker_phone
        this.mobile_phone = this.getUser.phone
        this.additional_phone = this.getUser.additional_phone
        this.skype = this.getUser.skype
        this.email = this.getUser.email
        this.about = this.getUser.about
        this.password = this.getUser.password
        this.token = localStorage.getItem ( 'token' )
        this.file = []
        this.url = this.getUser.photo
        this.position = this.getUser.profile_position
        this.timezone = this.getUser.user_timezone
        this.user = this.getUser;
        //TODO: Добавить поддержку часовых поясов
        //this.timezone = this.getUser.timezone
      }
    },
    send() {
      if (this.new_password && this.old_password) {
        this.validatePassword()
      }
      if (!this.errors.any()) {
        this.$validator.validateAll().then(success => {
          this.worker_phone_error = null;
          this.additional_phone_error = null;
          this.mobile_phone_error = null;
          if (this.worker_phone || this.additional_phone || this.mobile_phone ){
            if((this.worker_phone && this.worker_phone.indexOf('_') !== -1) || (this.additional_phone && this.additional_phone.indexOf('_') !== -1) || (this.mobile_phone && this.mobile_phone.indexOf('_') !== -1)) {
              this.worker_phone_error = this.worker_phone && this.worker_phone.indexOf('_') !== -1 ?  'Поле телефон не заполнено.' : null;
              this.additional_phone_error = this.additional_phone && this.additional_phone.indexOf('_') !== -1 ?  'Поле телефон не заполнено.' : null;
              this.mobile_phone_error = this.mobile_phone && this.mobile_phone.indexOf('_') !== -1 ?  'Поле телефон не заполнено.' : null;
              return
            }
          }

          if (success) {
            let formData = new FormData();
            formData.append('file', this.file);
            formData.append('name', this.name ? this.name : '');
            formData.append('surname', this.surname ? this.surname : '');
            formData.append('patronymic', this.patronymic ? this.patronymic : '');
            formData.append('city', this.city ? this.city : '');
            formData.append('worker_phone', this.worker_phone ? this.worker_phone : '');
            formData.append('phone', this.mobile_phone ? this.mobile_phone : '');
            if (this.additional_phone) {
              formData.append('additional_phone', this.additional_phone);
            }
            if (this.timezone) {
              formData.append('user_timezone', this.timezone);
            }
            formData.append('skype', this.skype ? this.skype : '');
            formData.append('email', this.email ? this.email : '');
            formData.append('about', this.about ? this.about : '');
            if (this.new_password && this.old_password) {
              formData.append('new_password', this.new_password ? this.new_password : '');
              formData.append('old_password', this.old_password ? this.old_password : '');
            }
            formData.append('token', localStorage.getItem('token'));
            formData.append('profile_position', this.position ? this.position : '');
            //TODO: Добавить поддержку часовых поясов
            formData.append('timezone', this.timezone ? this.timezone : '');
            this.$http.post( '/change-user-info',
                formData,
                {
                  headers: {
                    'Content-Type': 'multipart/form-data'
                  }
                }
            ).then((response) => {
              if (response.data.success) {
                this.$toast.success('Данные успешно изменены!');
                this.$store.dispatch('fetchUserInfo')
                this.old_password = '';
                this.new_password = '';
                store._vm.getCompany.photo = this.getAvatar(this.url);
                this.afterSave();
              }
              if (response.data.old_password_error) {
                  this.errors.add({
                      field: 'old_password',
                      msg: 'Неверный пароль'
                  })
              }

            }).catch(() => {
              this.$toast.error('Ошибка!');
            })
          }
        })
      }
    },
    validatePassword () {
      var regexp = /[а-яё]/i;
      if(regexp.test(this.new_password)) {
        this.errors.add({
          field: 'new_password',
          msg: 'Поле пароль не должно содержать кириллицу'
        })
      }
      // const name = this.name.toLowerCase()
      // if (this.new_password.indexOf(this.name) !== -1 || this.new_password.indexOf(name) !== -1) {
      //   this.errors.add({
      //     field: 'new_password',
      //     msg: 'Поле пароль не должно содержать имя'
      //   })
      // }
      // const email = this.email.split('@')
      // if (this.new_password.indexOf(email[0]) !== -1 || this.new_password.indexOf(email[0].toLowerCase()) !== -1) {
      //   this.errors.add({
      //     field: 'new_password',
      //     msg: 'Поле пароль не должно содержать email'
      //   })
      // }
      // const chars = this.new_password.match(/[A-Za-z]/g)
      // if (!chars || chars.length < 1) {
      //   this.errors.add({
      //     field: 'new_password',
      //     msg: 'Поле пароль должно содержать минимум 1 символа латинского алфавита'
      //   })
      // }
      // const numbers = this.new_password.match(/[0-9]/g)
      // if (!numbers || numbers.length < 1) {
      //   this.errors.add({
      //     field: 'new_password',
      //     msg: 'Поле пароль должно содержать минимум 1 цифры'
      //   })
      // }
      //
      // const chars1 = this.old_password.match(/[A-Za-z]/g)
      // if (!chars1 || chars1.length < 1) {
      //   this.errors.add({
      //     field: 'old_password',
      //     msg: 'Поле пароль должно содержать минимум 1 символа латинского алфавита'
      //   })
      // }
      // const numbers1 = this.old_password.match(/[0-9]/g)
      // if (!numbers1 || numbers1.length < 1) {
      //   this.errors.add({
      //     field: 'old_password',
      //     msg: 'Поле пароль должно содержать минимум 1 цифры'
      //   })
      // }
    },
    deletePhoto(){
      this.$http.post('/delete-profile-photo', {
        token: localStorage.getItem('token'),
      }).then(({data}) => {
        if (data.success) {
          this.url = 'https://api.superbaer24.ru/storage/';
          store._vm.getCompany.photo = this.getAvatar(require('@/assets/icons/user-nav.svg'));
          this.$toast.success('Фотография удалена!');
        }
      }).catch((error) => {
        console.log(error)
      })
    }
  }
}
</script>

<style scoped lang="scss">

.password-label {
    font-size: 18px;
    padding-bottom: 16px;
}

.wrapper_label {
    font-size: 14px !important;
}
.main {

  &__title {
    margin: 0 0 8px 8px;
    width: 33.33%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;

    .avatar {
      object-fit: cover;
      width: 100%;
      height: 100%;
    }

    .avatar_wrapper {
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      width: 118px;
      height: 118px;
      border: 1px solid #29A377;
      border-radius: 50%;
      overflow: hidden;
    }

    .avatar_wrapper:hover .avatar_hover {
      opacity: 1;
    }

    .avatar_hover {
      opacity: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.4);
      transition: opacity .15s linear;
      cursor: pointer;

      img {
        width: 35px;
      }
    }
  }

  &__body {
    display: flex;
    flex-wrap: wrap;

    &-column {
      width: 33.33%;
      margin: 8px;

      h4 {
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 16px;
        color: #000000;
        margin: 0 0 5px 1px;
      }

      .dis {
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 16px;
        color: #7A818F;
      }

      .double {
        height: 117px;
      }

      input, textarea {
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 14px;
        color: #7A818F;
        padding: 10px;
        width: 100%;
        height: 40px;
        background: #FFFFFF;
        border: 1px solid #EEF0F3;
        box-sizing: border-box;
        border-radius: 4px;

        &-double {
          height: 117px;
        }

        &:disabled {
          font-family: Roboto;
          font-style: normal;
          font-weight: normal;
          font-size: 12px;
          line-height: 14px;
          color: #7A818F;
        }
      }


      .pass {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;

        a {
          font-family: Roboto;
          font-style: normal;
          font-weight: normal;
          font-size: 12px;
          line-height: 14px;
          text-decoration-line: underline;
          color: #7A818F;
        }
      }

      .password {
        position: relative;
      }
    }
  }

  .input-block {
    margin-bottom: 15px;

    textarea {
      height: 116px !important;
      resize: none;
    }
  }

}

.photo_trash{
  margin-left: 10px;
  width: 24px!important;
}
</style>
